export default function Logo() {
  return (
    <div className="flex items-center gap-2">
      <img src="/assets/images/logo/reddicks-icon.png" alt="Reddicks" className="h-8 w-auto" />
      <span className="text-xl font-bold tracking-[0.08em] text-primary-400">RSwap</span>
    </div>
  );
}
